import styled from 'styled-components';

export const FixedHeader = styled.header`
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #fff;
`;
